
document.addEventListener('DOMContentLoaded', () => {
  const MAX_QTY = 5;
  const PRODUCT_HANDLE = 'mbs-powder';

  if (!window.location.pathname.includes(
    '/products/' + PRODUCT_HANDLE
  )) return;

  function limitQuantity() {
    document.querySelectorAll(
      'input[name="quantity"]'
    ).forEach(input => {
      input.setAttribute('max', MAX_QTY);

      const quantity = Number(input.value);

      if (quantity > MAX_QTY) {
        input.value = MAX_QTY;
        input.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    });
  }

  document.addEventListener('click', event => {
    if (event.target.closest(
      'button, quantity-input'
    )) {
      requestAnimationFrame(limitQuantity);
    }
  });

  document.addEventListener('change', limitQuantity);
  limitQuantity();
});
